/**
 * R138g · Feb 2026 — Return the caller's LOCAL wall-clock as an ISO
 * string (no `Z`, no offset) suitable for the backend's naive-datetime
 * future-block guard on POST /time-entries/{id}/submit and
 * POST /workspaces/{ws}/time-entries. Skipping this on `/submit`
 * caused users in +TZ workspaces to be wrongly told the block hadn't
 * ended yet (server compared its UTC clock against naive local end).
 */
export function localWallClockIso() {
  const now = new Date();
  const localMs = now.getTime() - now.getTimezoneOffset() * 60000;
  return new Date(localMs).toISOString().slice(0, 19);
}
